import { render } from "./Wysiwyg.vue?vue&type=template&id=5854c800"
import script from "./Wysiwyg.vue?vue&type=script&lang=js"
export * from "./Wysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__